import React, { useEffect } from "react";

/**
 * Higher Order Component that triggers a side effect.
 * A convenience HOC that wraps a component and fires a function using useEffect.
 * @param {React.Component} Wrapped
 * @param {function} effect
 */
function withSideEffect(Wrapped, effect) {
  return (props) => {
    useEffect(() => {
      effect();
    }, []);
    return <Wrapped {...props} />;
  };
}

export default withSideEffect;
